module.exports = __webpack_public_path__ + "img/dangerHubHeader1.6443c2eb.png";